import { ref, reactive } from 'vue'
import apiClient from '@/plugins/axios'

export function useApi() {
  const loading = ref(false)
  const error = ref(null)
  
  const state = reactive({
    data: null,
    loading: false,
    error: null
  })
  
  const request = async (url, options = {}) => {
    loading.value = true
    state.loading = true
    error.value = null
    state.error = null
    
    try {
      const response = await apiClient(url, options)
      state.data = response.data
      return response.data
    } catch (err) {
      const message = err.response?.data?.message || 'Request failed'
      error.value = message
      state.error = message
      throw err
    } finally {
      loading.value = false
      state.loading = false
    }
  }
  
  const get = async (url, config = {}) => {
    return request(url, { method: 'GET', ...config })
  }
  
  const post = async (url, data = {}, config = {}) => {
    return request(url, { method: 'POST', data, ...config })
  }
  
  const put = async (url, data = {}, config = {}) => {
    return request(url, { method: 'PUT', data, ...config })
  }
  
  const patch = async (url, data = {}, config = {}) => {
    return request(url, { method: 'PATCH', data, ...config })
  }
  
  const del = async (url, config = {}) => {
    return request(url, { method: 'DELETE', ...config })
  }
  
  return {
    // State
    loading,
    error,
    state,
    
    // Methods
    request,
    get,
    post,
    put,
    patch,
    delete: del
  }
} 